import { useContext } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { useMutation, useQuery } from '@apollo/client'

import notifier from 'tools/Notify'
import { handleOneResponse } from 'utils/response'

import { UPDATE_USER } from 'common/User/graphql'
import { updateSettings } from 'common/User/normalize'
import { ORG_ID_FROM_SHORT_ID } from 'hub/Org/graphql'
import GlobalContext, { R_GLOBAL } from 'reducer/global'

function setActiveOrg(changeUser, dispatch, user, orgId) {
  const settings = updateSettings(user.settings, { activeOrgId: orgId })
  changeUser({
    variables: {
      id: user.id,
      user: {
        settings: JSON.stringify(settings)
      }
    }
  })
    .then(handleOneResponse('data', 'updateUser'))
    .then((user) => {
      dispatch({ type: R_GLOBAL.USER_SET, value: user })
    })
    .catch(notifier.onCatch(dispatch))
}

export function AssertActiveOrg({ root }) {
  const [{ user }, dispatch] = useContext(GlobalContext)
  const [changeUser] = useMutation(UPDATE_USER)
  const { targetId: paramId } = useParams()
  const history = useHistory()
  const activeOrgId = user?.org?.id

  useQuery(ORG_ID_FROM_SHORT_ID, {
    skip: !paramId || paramId === '_',
    variables: {
      id: paramId
    },
    fetchPolicy: 'cache-first',
    onCompleted({ orgs }) {
      const orgId = orgs?.results?.[0]?.id
      if (orgs.success && orgId != null) {
        if (orgId !== activeOrgId) {
          setActiveOrg(changeUser, dispatch, user, orgId)
        }
      } else {
        history.replace(root)
      }
    },
    onError(err) {
      notifier.warn(dispatch, 'Unauthorized')
    }
  })

  return null
}
